module.exports = __webpack_public_path__ + "static/patricia_testimonial-4296e63671473a8f776627918358dc08.jpg";